export { uploadImage as default } from "@services/api";
